module.exports = __webpack_public_path__ + "static/media/app-store.5e7ff64a.png";